import { render, staticRenderFns } from "./lock.vue?vue&type=template&id=b990d5f8&scoped=true"
import script from "./lock.vue?vue&type=script&lang=js"
export * from "./lock.vue?vue&type=script&lang=js"
import style0 from "./lock.vue?vue&type=style&index=0&id=b990d5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b990d5f8",
  null
  
)

export default component.exports